import {fetchApi, fetchCdn} from '@/helpers/fetchData'
import type { IAddress } from '@/types/address.ts'

interface ICreateToken {
  email: string
  consent_marketing: boolean
  vrm?: string
  vin?: string
  offer_id?: string
  cookiebot_consent_marketing?: string
}

export const createToken = (payload: ICreateToken) => {
  return fetchApi('/create-token.php', {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: {'Content-Type': 'application/json'},
  })
}

export const appendData = (payload: any) => {
  return fetchApi('/append-data.php', {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: {'Content-Type': 'application/json'},
  })
}

interface IGetImage {
  make: string
  model: string
  modelYear: string
  customer: string
  countryCode: string
  fileType: string
}

export const getImage = ({make, model, modelYear}: IGetImage) => {
  return fetchCdn(
    `/getImagem?make=${make}&model=${model}&modelYear=${modelYear}&customer=uk-johnsonlawgroup&countryCode=UK&fileType=jpg`,
  )
}

export const showClaim = (token: string) => {
  return fetchApi(`/show-claim.php?token=${token}`)
}

export const searchAddress = (postalCode: string) => {
  return fetchApi(`/postal-code.php?postal_code=${encodeURI(postalCode.replace(/\s+/, ""))}`)
}

export const creditReport = (token: string, code: string) => {
  return fetchApi(`/credit-report.php`, {
    method: 'POST',
    body: JSON.stringify({token, code}),
    headers: {'Content-Type': 'application/json'},
  })
}

export const reSendInvitation = (token: string) => {
  return fetchApi(`/re-send-invitation.php`, {
    method: 'POST',
    body: JSON.stringify({token}),
    headers: {'Content-Type': 'application/json'},
  })
}

export const sendRatingFeedback = (token: string, rating: string, feedback: string) => {
  return fetchApi(`/feedback.php`, {
    method: 'POST',
    body: JSON.stringify({token, rating, feedback}),
    headers: {'Content-Type': 'application/json'},
  })
}

export const changePhone = (token: string, phone: string) => {
  return fetchApi(`/change-phone.php`, {
    method: 'POST',
    body: JSON.stringify({token, phone}),
    headers: {'Content-Type': 'application/json'},
  })
}

export const addressLookup = (token: string, step: string = 'LookupAddresses'): Promise<IAddress[]> => {
  return fetchApi(`/address-lookup.php?token=${token}&step=${step}`)
}

interface IInviteToCreditReport {
  token: string
  addresses: IAddress[]
}

export const inviteToCreditReport = (payload: IInviteToCreditReport) => {
  return fetchApi(`/invite-to-credit-report.php`, {
    method: 'POST',
    body: JSON.stringify({
      ...payload,
      step: 'CreditReportInvite',
    }),
    headers: {'Content-Type': 'application/json'},
  })
}
